type SpeechRecognitionOptions = {
  langs: string[];
  processLocally?: boolean;
  quality?: "command" | "dictation" | "conversation";
};

type SpeechRecognitionAvailability = "available" | "downloadable" | "downloading" | "unavailable";

export type SpeechRecognizer = {
  continuous: boolean;
  interimResults: boolean;
  lang: string;
  processLocally?: boolean;
  unspokenPunctuation?: boolean;
  onend: (() => void) | null;
  onerror: ((event: SpeechRecognitionErrorEvent) => void) | null;
  onresult: ((event: SpeechRecognitionEvent) => void) | null;
  abort(): void;
  start(): void;
  stop(): void;
};

type SpeechRecognizerConstructor = {
  new (): SpeechRecognizer;
  available?: (options: SpeechRecognitionOptions) => Promise<SpeechRecognitionAvailability>;
  install?: (options: SpeechRecognitionOptions) => Promise<boolean>;
};

export const getSpeechRecognizerConstructor = (): SpeechRecognizerConstructor | undefined => {
  if (typeof window === "undefined") return undefined;
  const candidates = window as unknown as {
    SpeechRecognition?: SpeechRecognizerConstructor;
    webkitSpeechRecognition?: SpeechRecognizerConstructor;
  };

  return candidates.SpeechRecognition ?? candidates.webkitSpeechRecognition;
};
